import {formatDate} from "@ui-seeker/utils";

export default function dateColumn(name, label) {
    return {
        name: name, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: value => formatDate(value, { isString: true})
        }
    }
}